import Image from "next/image";
import React from "react";

export default function NoData() {
  return (
    <div className="no_data">
      <Image src={"/icons/No-Data.png"} alt="Image" width={110} height={110} />
      <p>No Data Found</p>
    </div>
  );
}
